import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

export default (data) => {

  const rep = get(data, 'fCategoriesRep', [])

  const items = rep && rep.map(item => {
    
    const title = get(item, 'fCategoryName', null);

    const galleryItemsArr = item.fCategoryItemsRep ? get(item, 'fCategoryItemsRep', []) : [];

    const galleryItems = galleryItemsArr.map(galleryItem => {
      
      const itemTitle = get(galleryItem, 'fCategoryItemName', null);

      const image = galleryItem.fCategoryItemImage ? refactorRespImg(galleryItem.fCategoryItemImage, [{
        size: 'default',
        key: 'image_size_395xANY'
      }]) : null

      // const overlayImg = galleryItem.fCategoryItemImage ? refactorRespImg(galleryItem.fCategoryItemImage, [{
      //   size: 'default',
      //   key: 'image_size_840xANY'
      // }]) : null

      const src = get(galleryItem, 'fCategoryItemImage.sourceUrl', '');
      // const webp = src.replace('.png', '.webp').replace('.jpg', '.webp');
      const jpg = src.replace('.png', '.jpg');

      const overlayImg = {
        alt: get(image, 'alt', ''),
        sizes: {
          default: {
            png: src,
            jpg,
            // webp,
          }
        }
      }

      return {
        title: itemTitle,
        image,
        overlay: {
          galleryItem,
          image: overlayImg,
          title: itemTitle,
          text: get(galleryItem, 'fCategoryItemDescription', null)
        }
      }
    })
    return title ? {
      title: title,
      items: galleryItems
    } : {}
  })

  return {
    title: get(data, 'fFeaturesHeading', null),
    items: items,
  }
}